import type { ReactNode } from 'react';

import type { HTMLBlockContainerTagName } from 'types';
import { cn } from 'utils/classNames';

import type { ItemSize } from './types';

interface Props {
	as?: HTMLBlockContainerTagName;
	children: ReactNode;
	className?: string;
	size?: ItemSize;
}

/** Grid for the items. */
export default function ImagesGrid({
	as: Component = 'div',
	children,
	className,
	size = 'regular',
}: Props) {
	return (
		<Component
			className={cn(
				'grid items-start gap-r-md',
				size === 'regular' && 'grid-cols-2 sm:grid-cols-3 md:grid-cols-6',
				size === 'large' && 'grid-cols-1 sm:grid-cols-2 md:grid-cols-4',
				className,
			)}
		>
			{children}
		</Component>
	);
}
ImagesGrid.displayName = 'BlockShortcutImages_ImagesGrid';
